import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";/* DEPRECATED. SEE DropdownToggleV2 */
import styled from '@emotion/styled'
import {ExpandMore} from '@mui/icons-material'
import {forwardRef,} from 'react'

import makeFieldColorPalette from '../styles/helpers/makeFieldColorPalette'
import {PALETTE} from '../styles/paletteV3'
import ui from '../styles/ui'

const DropdownIcon = styled(ExpandMore)({
  color: PALETTE.SLATE_600,
  marginLeft: 8
})

const DropdownBlock = styled('div')({
  display: 'inline-block',
  margin: '0 auto',
  maxWidth: '100%',
  width: '100%'
})







const InputBlock = styled('div')(
  ({disabled, size}) => ({
    ...ui.fieldBaseStyles,
    ...ui.fieldSizeStyles[size],
    ...makeFieldColorPalette('white', !disabled),
    cursor: 'pointer',
    position: 'relative',
    userSelect: 'none'
  }),
  ({disabled}) => disabled && {...ui.fieldDisabled},
  ({flat}) => flat && {borderColor: 'transparent'},
  {
    alignItems: 'center',
    display: 'flex'
  }
)

const Value = styled('span')({
  display: 'flex',
  flex: 1,
  minWidth: 0
})












const DropdownMenuToggle = forwardRef((props, ref) => {
  const {className, onClick, onMouseEnter, defaultText, disabled, flat, size} = props
  return (
    _jsx(DropdownBlock, {
      className: className,
      onMouseEnter: onMouseEnter,
      ref: ref,
      onClick: disabled ? undefined : onClick,
 children: 
      _jsxs(InputBlock, { disabled: !!disabled, flat: flat, size: size || 'medium', tabIndex: 0, children: [
        _jsx(Value, { children: defaultText})
        , !disabled && _jsx(DropdownIcon, {} )
      ]})
    })
  )
})

export default DropdownMenuToggle
